import { render } from "./Generate_Document.vue?vue&type=template&id=1af81792"
import script from "./Generate_Document.vue?vue&type=script&lang=js"
export * from "./Generate_Document.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__